import { mainApiSlice } from "../api/mainApiSlice";
import { API_BASE_URL } from "../../../configurations/configurations";

export const settingsApi = mainApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // chiamata iniziale che ottiene il settings necessario per la visualizzazione della schermata di login
    getUserSettingsById: builder.query({
      query: (userId) => ({
        url: `${API_BASE_URL}/settings/${userId}`,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetUserSettingsByIdQuery } = settingsApi;
